<template>
  <div>
    <div v-if="loading">
      <Loading />
    </div>
    <div v-else>
      <div v-if="videoGenerated">
        <VideoPlayer v-if="src" :src="src" />
      </div>
      <div v-if="videoUrl">
        <VideoItem
          :video-src="videoUrl"
          :autoplay="true"
          :muted="false"
          :controls="true"
          @onVideoEnded="onVideoEnded"
        ></VideoItem>

        <div
          v-if="videos.length > 0"
          class="column is-12 is-inline-flex is-justify-content-center"
        >
          <nav class="pagination" role="navigation">
            <a
              class="pagination-previous"
              v-if="currentVideo > 1"
              v-on:click="prev()"
              >Anterior</a
            >
            <a
              class="pagination-previous"
              v-if="currentVideo < videos.length"
              v-on:click="next()"
              >Siguiente</a
            >

            <ul class="pagination-list">
              <li v-if="currentVideo > 2">
                <a
                  class="pagination-link"
                  @click="goto(1)"
                  aria-label="Goto page 1"
                  >1</a
                >
              </li>

              <li v-if="currentVideo > 3">
                <span class="pagination-ellipsis">&hellip;</span>
              </li>
              <li v-if="currentVideo > 1">
                <a
                  class="pagination-link"
                  v-on:click="goto(currentVideo - 1)"
                  >{{ currentVideo - 1 }}</a
                >
              </li>
              <li>
                <a
                  class="pagination-link is-current"
                  v-on:click="goto(currentVideo)"
                  aria-current="page"
                  >{{ currentVideo }}</a
                >
              </li>
              <li v-if="videos.length > currentVideo">
                <a
                  class="pagination-link"
                  v-on:click="goto(currentVideo + 1)"
                  >{{ currentVideo + 1 }}</a
                >
              </li>
              <li v-if="videos.length - currentVideo > 2">
                <span class="pagination-ellipsis">&hellip;</span>
              </li>

              <li v-if="videos.length - currentVideo > 1">
                <a class="pagination-link" v-on:click="goto(videos.length)">{{
                  this.videos.length
                }}</a>
              </li>
            </ul>
          </nav>

          <div class="field has-addons ml-2">
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="search"
                @input="filtrarNumero"
              />
            </div>
            <div class="control">
              <a
                class="button is-primary"
                placeholder="Ingresa número de video a comenzar"
                @click="searchVideo"
              >
                Ver
              </a>
            </div>
            <div class="control ml-2">
              <a class="button" @click="reset">
                Reiniciar
              </a>
            </div>
          </div>
        </div>
        <div class="column is-12 has-text-centered">
          <p>
            Descargar Video (Esto puede tardar, dependiendo de la cantidad de
            videos)
          </p>
          <small>
            <strong>Nota:</strong> Tenga en cuenta que la unión del video podría
            sufrí interrupciones en el momento de la descarga y podría no unirse
            bien, por esta razón se le presenta dos opciones. Puede descargar
            todos los segmentos en un .zip o tratar de obtener el video con la
            unión de los segmentos.
          </small>
        </div>
        <div
          class="column is-12 is-inline-flex is-justify-content-center"
          v-if="loadingDownload"
        >
          <Loading />
        </div>
        <div class="column is-12 is-inline-flex is-justify-content-center">
          <button
            class="button"
            @click="downloadZip"
            :disabled="loadingDownload"
          >
            Descargar todos los videos en un .zip
          </button>
        </div>
        <div class="column is-12 is-inline-flex is-justify-content-center">
          <button class="button" @click="download" :disabled="loadingDownload">
            Descargar en un solo video
          </button>
        </div>
      </div>
      <div v-else>
        <p class="mb-4">{{ $t("video-evidence.video-not-generated") }}</p>

        <p v-if="message" class="mb-4">{{ message }}</p>

        <button class="button" @click="getVideoStorage">Ver Vídeo</button>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import VideoPlayer from "@/components/video/VideoPlayer.vue";
import { RepositoryFactory } from "@/services/api";
import VideoItem from "@/components/video/VideoItem.vue";

export default {
  name: "video-evidence",
  components: {
    VideoPlayer,
    VideoItem,
    Loading,
  },
  props: {
    roomId: {
      type: String,
      required: true,
    },
    roomName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      video: null,
      src: null,
      loading: false,
      loadingDownload: false,
      videoUrl: null,
      videos: [],
      message: "",
      currentVideo: 1,
      search: "",
    };
  },
  async mounted() {
    await this.retrieveVideo();
    if (this.video) {
      this.retrieveVideoStreamUrl();
    }
  },
  computed: {
    videoGenerated() {
      return this.video;
    },
    getRoomName() {
      return this.roomName
        ? this.roomName.replace(/ /gi, "_").replace(/,/gi, "")
        : this.roomId;
    },
  },
  methods: {
    async retrieveVideo() {
      this.loading = true;
      try {
        let response = await RepositoryFactory.conference.getVideos({
          roomId: this.roomId,
        });
        this.video = response.data[0];
      } catch (error) {
        window.console.log(error);
      }
      this.loading = false;
    },
    async retrieveVideoStreamUrl() {
      let url = RepositoryFactory.conference.getVideoStreamUrl({
        videoId: this.video.id,
      });
      this.src = url;
    },
    async onVideoEnded() {
      if (this.videos[this.currentVideo]) {
        this.currentVideo = this.currentVideo + 1;
        if (this.videos[this.currentVideo - 1]) {
          this.responseStreamStorage(this.videos[this.currentVideo - 1]);
        }
      }
    },
    async paginationVideo() {
      if (this.videos[this.currentVideo - 1]) {
        this.responseStreamStorage(this.videos[this.currentVideo - 1]);
      }
    },
    async getVideoStorage() {
      this.loading = true;
      try {
        let paths = await RepositoryFactory.conference.getVideoStoragePaths({
          roomId: this.roomId,
        });

        if (paths.status === 200 && paths.data && paths.data.length > 0) {
          this.videos = paths.data;
          this.responseStreamStorage(this.videos[this.currentVideo - 1]);
        } else {
          this.message = "No se encontró video para mostrar";
        }

        this.loading = false;
      } catch (error) {
        this.message = error;
        this.loading = false;
      }
    },
    async responseStreamStorage(path) {
      var response = await RepositoryFactory.conference.getVideoStreamStorage({
        path: path,
      });
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.data.type,
        });
        const url = URL.createObjectURL(blob);
        this.videoUrl = url;
      } else {
        this.message = "Error al intentar buscar video";
      }
    },
    goto(currentVideo) {
      this.currentVideo = currentVideo;
      this.paginationVideo();
    },
    next() {
      this.currentVideo = this.currentVideo + 1;
      this.paginationVideo();
    },
    prev() {
      this.currentVideo = this.currentVideo - 1;
      this.paginationVideo();
    },
    reset() {
      this.currentVideo = 1;
      this.video = null;
    },
    searchVideo() {
      this.currentVideo = this.search * 1;
      this.paginationVideo();
      this.search = "";
    },
    filtrarNumero(event) {
      this.search = event.target.value.replace(/[^0-9]/g, "");
      if (this.search > this.videos.length) {
        this.search = this.currentVideo;
      }
    },
    async downloadZip() {
      this.loadingDownload = true;
      try {
        let response = await RepositoryFactory.conference.getVideoStorageZip({
          roomId: this.roomId,
        });
        if (response.status === 200) {
          this.downloadBlob(response.data, this.getRoomName);
          this.loadingDownload = false;
        } else {
          this.loadingDownload = false;
        }
      } catch (error) {
        console.log(error);
        this.message = error;
        this.loadingDownload = false;
      }
    },
    async download() {
      this.loadingDownload = true;
      try {
        let response = await RepositoryFactory.conference.getVideoStorageDownload(
          { roomId: this.roomId }
        );
        if (response.status === 200) {
          this.downloadBlob(response.data, `${this.getRoomName}.mp4`);
          this.loadingDownload = false;
        } else {
          this.loadingDownload = false;
        }
      } catch (error) {
        console.log(error);
        this.message = error;
        this.loadingDownload = false;
      }
    },
    downloadBlob(data, fileName) {
      const blob = new Blob([data], {
        type: data.type,
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      link.click();
    },
  },
};
</script>
